/**
 * Almacen de comprobantes emitidos.
 *
 * En la demo los comprobantes viven en localStorage (no hay tabla todavia).
 * Este modulo es el unico lugar que conoce esa clave, para que Facturacion
 * (que escribe) e IVA Ventas (que lee) no se desincronicen si manana el
 * almacenamiento pasa a ser el backend: se cambia aca y nada mas.
 */

import { Comprobante } from './facturaService';

const STORAGE_KEY = 'ardel.facturacion.emitidas';

/** Comprobante tal como queda persistido. */
export interface ComprobanteEmitido extends Comprobante {
    emitidaEn: string;
}

export const leerComprobantes = (): ComprobanteEmitido[] => {
    try {
        const raw = localStorage.getItem(STORAGE_KEY);
        const parsed = raw ? JSON.parse(raw) : [];
        return Array.isArray(parsed) ? parsed : [];
    } catch {
        return [];
    }
};

export const guardarComprobantes = (rows: ComprobanteEmitido[]): void => {
    try {
        localStorage.setItem(STORAGE_KEY, JSON.stringify(rows));
    } catch {
        /* si el storage esta lleno el comprobante ya se emitio igual */
    }
};

/**
 * Fecha del comprobante ('DD/MM/YYYY') como Date local.
 * Devuelve null si el formato no es el esperado, para que quien filtre por
 * rango pueda descartar la fila en vez de comparar contra un Invalid Date.
 */
export const fechaComprobante = (fecha: string): Date | null => {
    const [d, m, y] = (fecha || '').split('/').map(Number);
    if (!d || !m || !y) return null;
    const date = new Date(y, m - 1, d);
    return Number.isNaN(date.getTime()) ? null : date;
};
